import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

var SimpleDate =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SimpleDate, _PureComponent);

  function SimpleDate() {
    _classCallCheck(this, SimpleDate);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimpleDate).apply(this, arguments));
  }

  _createClass(SimpleDate, [{
    key: "render",
    value: function render() {
      var date = this.props.date;
      return React.createElement("span", null, new Date(date).toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      }));
    }
  }]);

  return SimpleDate;
}(PureComponent);

export { SimpleDate as default };
SimpleDate.propTypes = {
  date: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};